
export function trackPage(page){
	// analytics.page(page);
}
export function trackEvent(event, data){
	// analytics.track(event, data);
}
